import axios from 'axios'
import 'element-plus/es/components/message/style/css'
import 'element-plus/es/components/message-box/style/css'
import { ElMessage, ElMessageBox } from 'element-plus'
import store from '@/store'
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: process.env.VUE_APP_BASE_API,
  // 超时
  timeout: 10000
})
service.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    const region = localStorage.getItem('region')
    const company = localStorage.getItem('company')
    if (token) {
      if (service.interceptors.request.status === 401) {
        // token 无效 跳转登录页面
        store.dispatch('app/logout')
        return Promise.reject(new Error('token已失效'))
      }
      // if(config.responseType){
      //   config.responseType = 'blob'
      // }
      config.headers['xm-token'] = token
      if (region && company) {
        config.headers.region = region
        config.headers.company = company
      } else {
        ElMessageBox.confirm('您的登录已失效请重新登录', 'Warning', {
          confirmButtonText: '确认',
          cancelButtonText: '关闭',
          type: 'warning',
          center: true
        })
          .then(() => {
            store.dispatch('app/logout')
          })
          .catch(() => {
            store.dispatch('app/logout')
          })
        return Promise.reject(new Error('身份验证失败'))
      }
    }
    return config
  },
  (error) => {
    return Promise.reject(new Error(error))
  }
)
service.interceptors.response.use(
  (response) => {
    if (response.data.type) {
      return response
    }

    if (response.status === 401) {
      // token 无效 跳转登录页面
      store.dispatch('app/logout')
      return Promise.reject(new Error('token已失效'))
    } else if (response.data.code === 0) {
      return response.data.payload
    } else {
      ElMessage.error(response.data.msg)
      return Promise.reject(new Error(response.data.msg))
    }
  },
  (error) => {
    console.error(error)
    error.response && ElMessage.error(error.response.data.msg)
    if (
      error.response.data.code === 401 ||
      error.response.data.code === 100401
    ) {
      ElMessageBox.confirm('您的登录已失效请重新登录', 'Warning', {
        confirmButtonText: '确认',
        cancelButtonText: '关闭',
        type: 'warning',
        center: true
      })
        .then(() => {
          store.dispatch('app/logout')
        })
        .catch(() => {
          store.dispatch('app/logout')
        })
    }
    return Promise.reject(new Error(error.response.data))
  }
)
export default service
